var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"confirm-modal-wrap"},[_c('span',[_vm._v(_vm._s(_vm.title))]),_c('div',[_c('button',{on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelButton))]),_c('button',{on:{"click":_vm.ok}},[_vm._v(_vm._s(_vm.okButton))])])])}
var staticRenderFns = []

export { render, staticRenderFns }